import { render, staticRenderFns } from "./InvoiceReturnView.vue?vue&type=template&id=5a5e6b6a"
import script from "./InvoiceReturnView.vue?vue&type=script&lang=js"
export * from "./InvoiceReturnView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports